import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Switch, Route } from 'react-router-dom'

import { requestLocationsUser } from '../actions/locationsActions'

import Loader from '../Shared/Loader'
import ErrorContainer from '../Shared/ErrorContainer'
import UserLocations from './UserLocations'
import UserMonitor from './UserMonitor'

const Wrapper = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 10px;
    padding-top: 20px;
`

const Title = styled.h1`
    margin-bottom: 30px;
`

class User extends Component {
    componentDidMount() {
        this.props.requestLocations(this.props.privateLink)
    }

    render() {
        const { locationsData, privateLink, loading, error } = this.props

        if (error) return <ErrorContainer error={error} />

        return (
            <Wrapper>

                {!loading ? null : <Loader />}

                <Title>Kiinteistöjen valvonta</Title>

                <Switch>
                    <Route exact path={`/asiakkaat/:privatelink`} render={props =>
                        <UserLocations
                            {...props}
                            locationsData={locationsData}
                            privateLink={privateLink}
                        />
                    } />

                    <Route path="/asiakkaat/:privatelink/:id" component={UserMonitor} />

                </Switch>

            </Wrapper>
        )
    }
}

const mapStoP = (state, ownProps) => {
    const loading = state.locationsData.loading || state.measurements.loading
    var error = ''
    if (state.clients.error) error = 'Asiakastietoja ei voitu ladata'
    if (state.locationsData.error) error = 'Kohdetietoja ei voitu ladata'
    if (state.measurements.error) error = 'Mittaustietoja ei voitu ladata'

    const privateLink = ownProps.match.params.privatelink
    return {
        locationsData: state.locationsData.userData[privateLink],
        privateLink: privateLink,
        loading: loading,
        error: error,
    }
}

const mapDtoP = dispatch => {
    return {
        requestLocations: privateLink => dispatch(requestLocationsUser(privateLink))
    }
}

export default connect(mapStoP, mapDtoP)(User)


// WEBPACK FOOTER //
// ./src/User/User.js